import type { SigningStatus } from "@/shared/types";

export interface OrderActionsConfig {
  showDownloadButton: boolean;
  showSignButton: boolean;
}

export function getOrderActions(signingStatus: SigningStatus | null): OrderActionsConfig {
  if (signingStatus === null || signingStatus === 0) {
    return {
      showDownloadButton: true,
      showSignButton: true,
    };
  }

  return {
    showDownloadButton: false,
    showSignButton: false,
  };
}
